export default __webpack_public_path__ + "assets/kiribati-flag.png";